import * as constants from '@/common/constants';

export default {
  methods: {
    getStoragePreviousChoice() {
      let previousChoice = localStorage.getItem(constants.PREVIOUS_CHOICE);

      try {
        previousChoice = JSON.parse(previousChoice);
      } catch (error) {
        console.error(error);
        previousChoice = {};
      }

      return previousChoice;
    },
    hasStoragePreviousChoiceData() {
      const previousChoice = this.getStoragePreviousChoice();

      return !(previousChoice === null || JSON.stringify(previousChoice) === '{}');
    },
    setStoragePreviousChoice(data) {
      localStorage.setItem(constants.PREVIOUS_CHOICE, JSON.stringify(data));
    },
    removeStoragePreviousChoice() {
      localStorage.removeItem(constants.PREVIOUS_CHOICE);
    },
    setStorageHemail(hemail) {
      localStorage.setItem(constants.LOCAL_STORAGE_CUSTOMER_HEMAIL, hemail);
    }
  }
};



// WEBPACK FOOTER //
// ./src/common/mixins/storage.js